// Factory de `t(key)` server-safe. Mesma lógica que vivia inline em
// SiteShell — extraída pra que Server Components que carregam o blob
// `strings` via `loadSiteData()` possam derivar `t` no servidor sem
// depender do LangContext (que é client-only).

export function makeT(strings, lang) {
  const root = strings ?? {};
  const scope = root[lang] ?? root;
  return (key) => {
    if (!scope || typeof scope !== "object") return "";
    const value = String(key)
      .split(".")
      .reduce((o, k) => (o && typeof o === "object" ? o[k] : null), scope);
    return value ?? "";
  };
}
